<template>
    <v-container :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'px-5 py-5': $vuetify.breakpoint.mdAndUp}">
        <div style="height: 35px;"/>
            <v-layout row wrap>
                <h2 style="font-size: 20px;  color: #1f97b9;">Hola ¿Cuál es tu nombre?</h2> 
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm6 md4 style="margin: auto;">
                    <v-text-field label
                        class="pointer"
                        v-model="datos.personales.nombre"
                        color="#1f97b9"
                        placeholder="Nombre"
                        ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 style="margin: auto;">
                    <v-text-field label
                        class="pointer"
                        v-model="datos.personales.apellido"
                        placeholder="Apellidos"
                        color="#1f97b9"
                        ></v-text-field>
                    
                </v-flex>
                <div>
                    <v-btn :disabled="datos.personales.nombre === '' || datos.personales.apellido === ''" @click="validate(true)" style="background-color: #1f97b9; color: #FFFFFF;">Continuemos</v-btn>
                </div>
            </v-layout>
            <v-layout style="margin: auto;">
                
            </v-layout>
            
    </v-container>
</template>

<script>
import { urlToHttpOptions } from 'url'
import { EventBus } from '../../../events.js'
export default {
    name: 'nombre',
    data () {
        return {
            datos: {
                personales: {
                        nombre: '',
						telefono: '',
						email: '',
                        apellido: '',
                        nombrePila: ''
					},
                date: '',
                time: '',
                direccion_origen:{
                    direccion: "",
                    marker: {},
                    direccion_obj: {},
                    estacionamiento: ''
                },
                direccion_destino:{
                    direccion: "",
                    marker: {},
                    direccion_obj: {},
                    estacionamiento: ''
                },
                oferta:{
                }
            }
        }
    },
    methods: {
        eventTracker(tipo) {
            gtag('event', tipo, {
            'event_category' : tipo,
            'event_label' : tipo
            })
        },
        validate(move) {
            this.datos.personales.nombrePila = this.datos.personales.nombre
            this.datos.personales.nombre = this.datos.personales.nombre + ' ' + this.datos.personales.apellido
            if (this.datos.personales.nombre !== '') {
                var data = {
                    datos: this.datos,
                    valid: true,
                    move
                    
                }
                this.eventTracker('cotizacionFirst')
                EventBus.$emit('mudanzaFirst', data);
                
            }
            
        },
        setAddress(data){
				// Seteamos la data de dirección como promesa para poder esperar que esto esté listo en retomarPedido abajo
      return new Promise((resolve, reject) => {
          const self = this
          const geocoder = new google.maps.Geocoder()
          const origen = new Promise((resolve, reject) => {
              geocoder.geocode({'address': data.direcciones.origen}, function(results, status) {
              if (status === 'OK') {
                  self.datos.direccion_origen.marker = results[0].geometry.location
              } else {
                  alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
              })
          })
          const destino = new Promise((resolve, reject) => {
            geocoder.geocode({'address': data.direcciones.destino}, function(results, status) {
              if (status === 'OK') {
                self.datos.direccion_destino.marker = results[0].geometry.location
              } else {
                alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
            })	
          })

          Promise.all([origen, destino]).then(values => { 
            resolve(true)
          });
        })  
      }
        
    },
    mounted() {
        EventBus.$on('retomarPedidoFirst', data => {
            this.datos.personales = data.personales
            EventBus.$emit('avanzarRetomar', {e1: 2})
        })
    }
}
</script>